module.exports = fox._r("images/fullscr.png", __webpack_public_path__ + "images/fullscr.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/fullscr.png
// module id = 1050
// module chunks = 4